import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";
import { HttpMethod } from "../../Common/useFetch";
import useUserRequest from "../../Common/useUserRequest";
import { RequestOptions } from "../../Common/useRequest";

const path = (businessId: string) => `/api/businesses/${businessId}/suppliers`;

const useRemoveSupplier = (supplierId?: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();

  return useUserRequest<void, void>({
    path: `${path(business.id)}/${supplierId}`,
    method: HttpMethod.DELETE,
  }, options);
}

export default useRemoveSupplier;
